import axios from '@plugins/axios'
import store from '@state/store'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

export const state = {
    municipality: [],
    department: [],
    country: [],
    loadingMunicipalities: false,
    loadingDepartments: false,
    loadingCountries: false,
}

export const getters = {
    municipality: state => state.municipality,
    department: state => state.department,
    country: state => state.country,
    loadingMunicipalities: state => state.loadingMunicipalities,
    loadingDepartments: state => state.loadingDepartments,
    loadingCountries: state => state.loadingCountries,
}

export const mutations = {
    SET_LOCATION(state, payload) {
        const type = payload.type
        const data = payload.data
        switch (type) {
            case 'municipality': state.municipality = data; break;
            case 'department': state.department = data; break;
            case 'country': state.country = data; break;
            default: break;
        }
    },
    SET_LOADING(state, payload) {
        const type = payload.type
        const data = payload.data
        switch (type) {
            case 'municipality': state.loadingMunicipalities = data; break;
            case 'department': state.loadingDepartments = data; break;
            case 'country': state.loadingCountries = data; break;
            default: break;
        }
    },
}

export const actions = {
    fetchLocations({ commit, state }, payload) {
        const type = payload.type
        const query = payload.query
        // evitar consultar nuevamente si ya existe
        if (state[type] && Object.keys(state[type]).length > 0) {
        } else {
            commit('SET_LOADING', { type: type, data: true })
            axios.get(appConfig.server_url + `/company/${type}/${query ? '?page_size=2000&' + query : '?page_size=2000'}`)
                .then(resp => {
                    if (resp.status === 200) {
                        commit('SET_LOCATION', { type: type, data: resp.data })
                    }
                    commit('SET_LOADING', { type: type, data: false })
                })
                .catch(() => {
                    commit('SET_LOADING', { type: type, data: false })
                    commit('SET_LOCATION', { type: type, data: null })
                    store.dispatch('utils/message', { type: 'error', title: 'Error', text: `Error consultando ${type}` })
                })
        }
    },
}